<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs @tab-click="dianji">
            <!-- 发件人策略 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.policy1") }}</span>
                <div class="main">
                    <p>

                        <span class="main_text"> {{ this.load_hind_pop }}</span>
                        <el-input v-model="address_pop" style="width:20%;margin-right:10px" clearable></el-input>
                        <el-button @click="save_pop_table()" :disabled="$root.jurisdiction.only_query==0"> {{ $t("logs.policy6") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table" v-if="envfrom_policy==0">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_pop" :row-class-name="tableRowClassName">
                            <el-table-column prop="SHOW_KEY" :label="$t('logs.policy7')" width="200">
                            </el-table-column>
                            <el-table-column prop="HINT" :label="$t('logs.policy8')">
                            </el-table-column>
                            <el-table-column prop="DFT_VALUE" :label="$t('logs.policy9')" width="200">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 收件人策略 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.policy2") }}</span>
                <div class="main">
                    <p>

                        <span class="main_text"> {{ this.load_hind_pop }}</span>
                        <el-input v-model="address_pop" style="width:20%;margin-right:10px" clearable></el-input>
                        <el-button @click="save_pop_table()" :disabled="$root.jurisdiction.only_query==0"> {{ $t("logs.policy6") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table" v-if="this.envfrom_policy==0">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_pop" :row-class-name="tableRowClassName">
                            <el-table-column prop="SHOW_KEY" :label="$t('logs.policy7')" width="200">
                            </el-table-column>
                            <el-table-column prop="HINT" :label="$t('logs.policy8')">
                            </el-table-column>
                            <el-table-column prop="DFT_VALUE" :label="$t('logs.policy9')" width="200">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- IP策略 -->

            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.policy3") }}</span>
                <div class="main">
                    <p>

                        <span class="main_text"> {{ this.load_hind_pop }}</span>
                        <el-input v-model="address_pop" style="width:20%;margin-right:10px" clearable></el-input>
                        <el-button @click="save_pop_table()" :disabled="$root.jurisdiction.only_query==0"> {{ $t("logs.policy6") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table" v-if="this.envfrom_policy==0">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_pop" :row-class-name="tableRowClassName">
                            <el-table-column prop="SHOW_KEY" :label="$t('logs.policy7')" width="200">
                            </el-table-column>
                            <el-table-column prop="HINT" :label="$t('logs.policy8')">
                            </el-table-column>
                            <el-table-column prop="DFT_VALUE" :label="$t('logs.policy9')" width="200">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanSend()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 已设置策略列表 -->
            <el-tab-pane label="">
                <span slot="label"> {{$t("logs.policy4")}}</span>

                <div class="table table_list_set">
                    <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList6" :row-class-name="tableRowClassName" v-loading="loading">
                        <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="60"> </el-table-column>

                        <el-table-column prop="POLICY" :label="$t('logs.policy7')"> </el-table-column>
                        <el-table-column prop="NOTE_TYPE" :label="$t('logs.policy12')"> </el-table-column>
                        <el-table-column prop="OBJ" :label="$t('logs.policy13')"> </el-table-column>
                        <el-table-column prop="address" :label="$t('logs.policy14')" width="200"> <template scope="scope">
                                <el-select size="small" v-model="scope.row.ACTION" placeholder="请选择">
                                    <el-option v-for="item in q_action_type" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                                <span>{{ scope.row.date }}</span>
                            </template> </el-table-column>
                        <el-table-column prop="address" :label="$t('logs.audit6')"> <template slot-scope="scope">
                                <!-- 保存-->

                                <el-button @click="handleClick_in(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.save") }}</el-button>

                            </template></el-table-column>
                    </el-table>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <div class="switch1" v-if="this.envfrom_policy==1">

                <div class="table table_policy">
                    <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList_group_pop" :row-class-name="tableRowClassName" v-loading="loading">
                        <el-table-column prop="SHOW_KEY" :label="$t('logs.policy7')" width="160">
                        </el-table-column>
                        <el-table-column prop="HINT" :label="$t('logs.policy8')">
                        </el-table-column>
                        <el-table-column prop="DFT_VALUE" :label="$t('logs.policy9')" width="110">
                        </el-table-column>
                        <el-table-column prop="address" :label="this.cfg_hint" width="160">
                            <template scope="scope">
                                <el-select size="small" v-model="scope.row.VALUE" placeholder="">
                                    <el-option v-for="item in q_action_type" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>

                            </template>
                        </el-table-column>
                        <el-table-column prop="address" :label="$t('logs.audit6')" width="80">
                            <template slot-scope="scope">
                                <!--保存-->

                                <el-button @click="save_group_list(scope.$index, scope.row)" type="text" size="small">{{ $t("table1.save") }}</el-button>

                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </div>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            fileList_group_pop: [],
            loading: false,
            envfrom_policy: '',
            address_pop: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            radio: [],
            fileList6: [],
            load_hind_pop: '',
            type_pop: 'from',
            cfg_hint: '',
        };
    },
    mounted() {
        this.load_group_pol_from()
    },
    methods: {
        // 加载
        getFileList6() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_pol_list",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList6 = res.data.ret.datalist;
                        this.load_hind7 = res.data.ret.LOAD_HINT;
                        this.actionn = res.data.ret.q_action;
                        // this.action = res.data.ret.ACTION;

                        // 总条数

                        this.loading = false;

                    }
                })
                
        },
        // 发件人策略加载
        load_group_pol_from() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_pol_lization",
                        sid: sid,

                        address: this.address_pop,
                        type: this.type_pop
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.load_hind_pop = res.data.ret.LOAD_HINT
                        this.fileList_group_pop = res.data.ret.datalist;
                        this.q_action_type = res.data.ret.q_action_type
                        this.envfrom_policy = res.data.ret.SHOW_CFG
                        // console.log(this.envfrom_policy)
                        // this.show_hint5 = res.data.ret.LOAD_HINT
                        this.cfg_hint = res.data.ret.CFG_HINT

                        this.loading = false;

                    }
                })
                
        },
        // 已设置，保存
        handleClick_in(index, scope) {

            // console.log(index, scope)

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let address = scope.OBJ
            let policy = scope.POLICY1

            let type = scope.TYPE
            let chkaction = scope.ACTION

            let str = this.$qs.stringify({
                __mode: "save_per_policy",
                sid: sid,

                address: address,
                policy: policy,

                type: type,
                chkaction: chkaction,

            });

            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.getFileList6()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                });

        },
        // 设置对象当前策略保存
        save_group_list(index, row) {
            console.log(index, row)
            // this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let str = this.$qs.stringify({
                __mode: "save_per_policy",
                sid: sid,

                address: this.address_pop,
                type: this.type_pop,
                chkaction: row.VALUE,
                policy: row.KEY

            });
            console.log(str)
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.loading = false;

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        // this.loading = false;
                        this.load_group_pol_from()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });

                    }
                })
                
        },
        // 组发信个性化设置
        save_pop_table() {
            this.load_group_pol_from()
        },
        dianji(a) {
            this.envfrom_policy=0
            console.log(a.index)
            this.address_pop = ''
            if (a.index == 0) {
                this.type_pop = 'from'
                this.load_group_pol_from()

            } else if (a.index == 1) {
                this.type_pop = 'to'
                this.load_group_pol_from()

            } else if (a.index == 2) {
                this.type_pop = 'connect'
                this.load_group_pol_from()

            } else if (a.index == 3) {
                this.getFileList6()
            }
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
// input 框高度
/deep/ .el-input__i nner {
    height: 30px;
}

.lie {
    margin: 2%;
    border: 1px solid #ddd;
    width: 96%;
    display: flex;
    justify-content: center;
}

.lie table {
    width: 100%;
}

.lie tbody {
    // width: 100%;
    display: flex;
    flex-direction: column;
    margin: 15px;

    tr {
        border: 1px solid #ddd;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        margin-bottom: -1px;
        display: flex;
        align-items: center;
    }
}

/deep/ .el-alert__content {
    padding: 0;
}

.lie tbody td {
    font-size: 14px;
    height: 100%;
}

.lie tbody td:nth-child(1) {
    width: 200px;

    text-align: right;
    padding-right: 20px;
}

.lie tbody td:nth-child(2) {
    display: flex;
    border-left: 1px solid #ddd;

    flex-direction: column;

    .el-input {
        width: 300px;
    }

    padding-left: 20px;

    div {
        padding: 2px 0;
        margin: 10px 0;
    }
}

// /deep/ .el-input--suffix {
//     width: 300px;
// }

//  /deep/ .el-select .el-input__inner {
//     margin-left: -30px;
// }

/deep/ .el-tabs__header {
    margin: 0;
}

.main-find {
    width: 100%;
    margin-top: 10px;
    padding-left: 10px;
    // padding-bottom: 5px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: left;

    span {
        margin-right: 8px;

        // width: 126px;
        // display: inline-block;
        color: #0E2C5E;
    }

    .el-input {
        margin-right: 8px;
        width: 20%;
        line-height: 26px;
        height: 26px;
        // padding: 5px 10px 5px 0;

    }

    // input 框高度
    /deep/ .el-input__inner {
        height: 26px;
        padding: 0 6px;
    }

    /deep/ .el-input--suffix {
        width: 150px;
        margin: 0 10px;
    }

}

// 1

// input 框高度
/deep/ .el-input__inner {
    height: 30px;
}

.el-checkbox-group {
    display: flex;
}

.table span {
    font-size: 14px;
}

// th  改高度
/deep/ .el-table th {
    padding: 4px 0;
}

// td  改高度
/deep/ .el-table td {
    padding: 4px 0;
}

/deep/ .cell {
    text-align: center;
}

// 时间
.time {
    display: flex;
    flex-direction: column;
    border: 1px solid #dcdfe6;
    background: #f1f1f1;
    margin: 10px 0;
}

.time1 {
    display: flex;
    align-items: center;
    padding: 2px 0 2px 14px;
    font-size: 14px;
}

// 手动设置
.time-text1 {
    padding-left: 20px;
}

// 后台管理控制
.back {
    display: flex;
    font-size: 14px;
    line-height: 30px;
    align-items: center;
    padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
    margin: 0 10px;
}

.backText {
    text-align: right;
}

.backText1 {
    color: #999;
    font-size: 12px;
}

.back .el-input {
    width: 20%;
    padding: 0;
}

.time2 {
    display: flex;
    margin-left: 190px;
    margin-top: 10px;
}

.time2 .el-button {
    padding: 8px 24px;
    // margin: 10px ;
}

// License
.time3 {
    display: flex;
    align-items: center;
    // margin-left: 150px;
    font-size: 14px;
    padding: 4px 10px;
}

// selece
.selece1 {
    width: 130px;
}

// input 框
.back1 .input1 {
    width: 100px;
    margin: 0 10px;
}

// 单选框
.check1 {
    margin: 0 10px;
}

.backText2 {
    margin-left: 40px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

.main {
    display: flex;

    align-items: center;
    border: 2px solid #D2D7E6;
    // background: #f1f1f1;
    // margin: 0px;

    text-align: left;
    // margin-top: 14px;
}

.main p {
    height: 44px;
    width: 100%;
    display: flex;
    padding-left: 10px;
    font-size: 12px;

    align-items: center;
    // line-height: 28px;
}

.main_text {
    margin-right: 6px;
    margin-left: 6px;
    color: #0e2c5e;
}

/deep/ .el-tabs__content:last-child {
    margin-top: 14px;
}
.table_list_set{
    .el-table{
    height: calc(72vh)};
}
</style>
